// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news-media-block[data-v-7e5008c6]{display:none}.news-media-block[data-v-7e5008c6]:first-child,.news-media-block[data-v-7e5008c6]:nth-child(2){display:flex}", ""]);
// Exports
module.exports = exports;
